/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/react-in-jsx-scope */
import './style.css'

import Camera from '../../img/pngwing.com (15) 1.png'

const ClubFreeSun = () => {
  return (
    <>
      <section className="club center">
        <h1 className="club-title">
          КЛУБ <span className="yellow-span">FREE SUN</span>
        </h1>

        <div className="club-conteiner">
          <div className="club-box">
            <div className="club-box-philosophy">
              <h3 className="club-philosophy-title">
                <span className="yellow-span">Философия:</span>
              </h3>
              <p className="club-philosophy-txt">
                Мы создаем <span className="yellow-span">сообщество</span>,
                объединяющее профессионалов кино, инвесторов и&nbsp;лучших
                выпускников киношколы, предоставляя{' '}
                <span className="yellow-span">поддержку</span>{' '}
                и&nbsp;возможность реализовать свои{' '}
                <span className="yellow-span">таланты</span> и&nbsp;идеи,
                а&nbsp;также создать профессиональное{' '}
                <span className="yellow-span">портфолио</span> благодаря
                реальным проектам. Это&nbsp;способствует{' '}
                <span className="yellow-span">развитию</span> новых талантов
                и&nbsp;<span className="yellow-span">созданию</span>{' '}
                качественных проектов, продвигающих киноиндустрию вперед.
              </p>
            </div>
            <div className="club-box-conditions">
              <h3 className="club-conditions-title">
                <span className="yellow-span">Условия участия:</span>
              </h3>
              <p className="club-conditions-txt">
                • <span className="yellow-span">Мастера курсов</span>{' '}
                и&nbsp;известные деятели кино и&nbsp;рекламы — бесплатное
                членство
              </p>
              <p className="club-conditions-txt">
                • <span className="yellow-span">Лучшие студенты</span> киношколы
                получают бесплатное членство по&nbsp;программе "Золотой бонус"
              </p>
              <p className="club-conditions-txt">
                • <span className="yellow-span">Инвесторы</span> киношколы
                автоматически становятся членами клуба
              </p>
            </div>
          </div>
          <div className="club-concept">
            <h3 className="club-concept-title">Концепция:</h3>
            <p className="club-concept-txt">
              Клуб функционирует как&nbsp;творческая лаборатория
              для&nbsp;создания рекламных и&nbsp;игровых проектов.
              Лучшие&nbsp;выпускники киношколы представляют разработанные
              тритменты на&nbsp;питчинге. Жюри&nbsp;выбирает{' '}
              <strong className="club-italic">самые сильные работы</strong>,
              которые{' '}
              <strong className="club-italic">
                получают возможность финансирования и&nbsp;реализации
              </strong>
            </p>
            <p className="club-concept-txt">
              Благодаря поддержке профессионалов и&nbsp;участию в&nbsp;реальных
              проектах с&nbsp;бюджетом{' '}
              <strong className="club-italic">
                выпускники получают незаменимый опыт
              </strong>
              , формируют портфолио и&nbsp;
              <strong className="club-italic">
                становятся полноправными участниками киносообщества
              </strong>
            </p>
          </div>
        </div>
      </section>

      <section className="slogal center">
        <div className="slogan-box">
          <h2 className="slogan-txt">
            <span className="yellow-span">Клуб Free Sun</span> — это место,
            где&nbsp;таланты раскрываются, проекты оживают, а&nbsp;
            <span className="yellow-span">
              возможности&nbsp;становятся реальностью
            </span>
            .
          </h2>
          <h2 className="slogan-txt">
            Присоединяйтесь к нашему сообществу,{' '}
            <span className="yellow-span">
              воплотите&nbsp;свои идеи в&nbsp;жизнь
            </span>{' '}
            и&nbsp;станьте частью будущего киноиндустрии.
          </h2>
        </div>
      </section>

      <section className="role center">
        <div className="role-container">
          <div className="role-container-1">
            <h3 className="role-title">РОЛЬ ЖЮРИ</h3>
            <p className="role-txt">
              • Оценивают разработанные проекты, предоставляют обратную связь
              и&nbsp;выбирают лучшие работы для реализации.
            </p>
          </div>
          <div className="role-container-2">
            <h3 className="role-title">РОЛЬ ВЫПУСКНИКОВ</h3>
            <p className="role-txt">
              • Разрабатывают проекты и&nbsp;участвуют в питчингах
              (от&nbsp;идеи&nbsp;до&nbsp;заявки).
            </p>
            <p className="role-txt">
              • Лучшие проекты получают финансирование, что дает участникам
              уникальный практический опыт и&nbsp;возможность добавить значимые
              работы в своё портфолио.
            </p>
          </div>
          <div className="role-container-3">
            <h3 className="role-title">РОЛЬ ИНВЕСТОРОВ</h3>
            <p className="role-txt">
              {' '}
              • Инвесторы могут заказывать рекламу, сценарии и к/м фильмы
              для&nbsp;своего бизнеса и&nbsp;финансируют выбранные проекты.
            </p>
          </div>
        </div>
      </section>

      <section className="free center">
        <img className="free-img" src={Camera} alt="" />
        <h2 className="free-sun">
          <span className="yellow-span">FREE SUN FILM SCHOOL —</span>
        </h2>
        <h3 className="free-kino">будь в фокусе кино!</h3>
      </section>
    </>
  )
}

export default ClubFreeSun
